import apiClient from "./BaseService";
import { URL } from "../config";

const _getExpenseEmployeeList = async (companyId: any) =>
  apiClient.get(`${URL.GET_EXPENSE_EMPLOYEES}${companyId}`);

const _getExpenseClaims = async (companyId: any) =>
  apiClient.get(`${URL.GET_EXPENSE_CLAIMS}${companyId}`);

const _getExpenseOnlyTemplate = async () =>
  apiClient.get(`${URL.GET_EXPENSE_ONLY_TEMPLATE}`);

const _getExpenseAndSelfServiceTemplate = async () =>
  apiClient.get(`${URL.GET_EXPENSE_AND_SELF_SERVICE_TEMPLATE}`);

const _getOwnExpenseClaims = async (companyId: any, from: any, to: any) =>
  apiClient.get(`${URL.GET_OWN_EXPENSE_CLAIMS}${companyId}`, {
    params: {
      from_date: from,
      to_date: to,
    },
  });

const _getAllExpenseClaims = async (companyId: any, from: any, to: any) =>
  apiClient.get(`${URL.GET_ALL_EXPENSE_CLAIMS}${companyId}`, {
    params: {
      from_date: from,
      to_date: to,
    },
  });

const _getToReviewExpenseClaims = async (companyId: any, from: any, to: any) =>
  apiClient.get(`${URL.GET_TO_REVIEW_EXPENSE_CLAIMS}${companyId}`, {
    params: {
      from_date: from,
      to_date: to,
    },
  });

const _getToPayExpenseClaims = async (companyId: any, from: any, to: any) =>
  apiClient.get(`${URL.GET_TO_PAY_EXPENSE_CLAIMS}${companyId}`, {
    params: {
      from_date: from,
      to_date: to,
    },
  });

const _getExpenseItems = async (companyId: any) =>
  apiClient.get(`${URL.GET_EXPENSE_ITEMS}${companyId}`);

const _saveExpenseUser = async (data: any) => {
    return apiClient.post(URL.SAVE_EXPENSE_EMPLOYEE, data)
}

const _submitExpenseClaim = async (data: any) => {
    return apiClient.post(URL.SUBMIT_EXPENSE_CLAIM, data)
}

const _rejectExpenseClaim = async (id: any) => {
    return apiClient.post(URL.REJECT_EXPENSE_CLAIM + `${id}/reject/`)
}

const _deleteExpenseClaim = async (id: any) => {
    return apiClient.delete(URL.DELETE_EXPENSE_CLAIM + `${id}/`)
}

const _updateExpenseClaim = async (id: any, data: any) => {
    return apiClient.patch(URL.UPDATE_EXPENSE_CLAIM + `${id}/`, data)
}

const _approveExpenseClaim = async (data: any) => {
    return apiClient.post(URL.APPROVE_EXPENSE_CLAIM, data)
}

const _saveExpenseItems = async (data: any) => {
    return apiClient.post(URL.SAVE_EXPENSE_ITEMS, data)
}

const _revokeExpenseAccess = async (id: any) => {
    return apiClient.post(`${URL.REVOKE_EXPENSE_ACCESS}${id}/revoke_access/`)
}

const _payExpenseClaims = async (data: any) => {
    return apiClient.post(`${URL.PAY_EXPENSE_CLAIMS}`, data)
}

// Expense Approval Groups

const _getExpenseApprovalGroups = async (companyId: any) =>
  apiClient.get(`${URL.GET_APPROVAL_GROUP_SETTINGS}?comp_id=${companyId}&feature=expense`);

const _createUpdateExpenseApprovalGroup = async (data: any) =>
    apiClient.post(URL.CREATE_OR_UPDATE_APPROVAL_GROUP_SETTING, data);

  const _deleteExpenseApprovalGroup = async (id: number) =>
    apiClient.delete(`${URL.DELETE_APPROVAL_GROUP_SETTINGS}${id}/`);

  const _getEmployeesEligibleToBeApprovers = async (companyId: any) =>
    apiClient.get(`${URL.GET_EXPENSE_APPROVAL_EMPLOYEE_LISTING}${companyId}&type=approvers`);

  const _getEmployeesEligibleToBeSubmitters = async (companyId: any) =>
    apiClient.get(`${URL.GET_EXPENSE_APPROVAL_EMPLOYEE_LISTING}${companyId}&type=submitters`);

export const ExpenseService = {
  _getExpenseEmployeeList,
  _saveExpenseUser,
  _revokeExpenseAccess,
  _getExpenseClaims,
  _getExpenseItems,
  _saveExpenseItems,
  _payExpenseClaims,
  _submitExpenseClaim,
  _getOwnExpenseClaims,
  _getToReviewExpenseClaims,
  _getToPayExpenseClaims,
  _rejectExpenseClaim,
  _approveExpenseClaim,
  _getAllExpenseClaims,
  _deleteExpenseClaim,
  _updateExpenseClaim,
  _getExpenseOnlyTemplate,
  _getExpenseAndSelfServiceTemplate,
  _getExpenseApprovalGroups,
  _createUpdateExpenseApprovalGroup,
  _deleteExpenseApprovalGroup,
  _getEmployeesEligibleToBeApprovers,
  _getEmployeesEligibleToBeSubmitters
};
